import React from 'react';
import { Collapse, Form } from 'antd';
import { status } from '../constants/status';

const CollapsedDeployemets = (props) => {

    return <Form.Item >
        {props.deployementsToShow.includes(status.deployed_and_running) && <Collapse
            activeKey={props.deployedActiveKey}
            onChange={props.handleDeployedPanelChange}
            style={{ marginTop: "15px", }}
            items={[
                {
                    key: 1,
                    label: 'Deployed',
                    children: <div>
                        {props.deployed}
                    </div>,
                },
            ]}
        />}
        {props.deployementsToShow.includes(status.ab_testing) && <Collapse
            activeKey={props.ABTestingActiveKey}
            onChange={props.handleABTestingPanelChange}
            style={{ marginTop: "15px", }}
            items={[
                {
                    key: 1,
                    label: 'A/B Testing',
                    children: <div>
                        {props.abTesting}
                    </div>,
                },
            ]}
        />}
        {props.deployementsToShow.includes(status.serving_paused) && <Collapse
            activeKey={props.pausedActiveKey}
            onChange={props.handlePausedPanelChange}
            defaultActiveKey={[2]}
            style={{ marginTop: "15px", }}
            items={[
                {
                    key: 1,
                    label: 'Paused',
                    children: <div>
                        {props.paused}
                    </div>,
                },
            ]}
        />}
        {props.deployementsToShow.includes(status.serving_ready) && <Collapse
            activeKey={props.readyToDeployActiveKey}
            onChange={props.handleReadyToDeployPanelChange}
            style={{ marginTop: "15px", }}
            items={[
                {
                    key: 1,
                    label: 'Ready to deploy',
                    children: <div>
                        {props.readyToDeploy}
                    </div>,
                },
            ]}
            ref={props.readyToDeployRef}
        />}
    </Form.Item>
};
export default CollapsedDeployemets;